import { useState, useEffect } from "react";

import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import { FormInput, FormDropDownList, FormTextArea } from "../FormComponents";
import { getTargetWorktype } from "../../../data/worktypeData";
import { getWorktypeGroupDropdown } from "../../../data/workTypeGroupData";
import { dropDown } from "../../../data/interfaces";

import SkeletonForm from "../../Skeletons/SkeletonForm";
import { saveInvoiceDescriptionUpdate } from "../../../data/saveInvoiceDescriptionUpdate";
import { v } from "../../../styles/variables";

export interface DescriptionObject {
  invoiceTemplateId: number
  name: string
  template: string
}

interface Props {
  description: DescriptionObject | undefined
  handleExpanded: () => void
  /** Without edit access: look, don't change. */
  readOnly?: boolean
}

const EditInvoiceDescriptionsForm = ({ description, handleExpanded, readOnly }: Props) => {

  const [formState, setFormState] = useState({
    description: description?.template,
    worktypeGroup: {
      value: 0,
      text: "",
    },
  });

  useEffect(() => {
    if(description) { 
      setFormState({
        ...formState,
        description: description?.template,
      });
    }
  }, [description])

  const handleSubmit = async () => {

    if (description === undefined || readOnly) return;
    saveInvoiceDescriptionUpdate(description?.name, formState.description || "", description?.invoiceTemplateId)
      .then(() => {
        handleExpanded();
      })
  };


  return description === undefined ? (
    <SkeletonForm />
  ) : (
    <div className="form__wrapper">
      <div style={{ display: "flex", width: "100%" }}>
        <Form
          onSubmit={handleSubmit}
          render={(formRenderProps) => (
            <FormElement
              style={{ padding: "1rem", width: "100%", marginBottom: "5rem" }}
            >
              <fieldset className={"k-form-fieldset"} disabled={readOnly}>
                <div className="form__subtitle">{readOnly ? "Description:" : "Edit Description:"}</div>
                {readOnly && <p className="k-form-hint">You have view-only access to invoice descriptions.</p>}
                <Field
                  onChange={(e) => {
                    console.log(e.value)
                    setFormState({
                      ...formState,
                      description: e.value
                    });
                  }}
                  height={"400px"}
                  name={"description"}
                  component={FormTextArea}
                  rows={20}
                  label={"Description: "}
                  defaultValue={formState.description}
                  disabled={readOnly}
                />

                {!readOnly && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    padding: "1rem 2rem 1rem 2rem",
                    position: "absolute",
                  }}
                >
                  <button
                    onClick={() => {
                      handleSubmit();
                      formRenderProps.onFormReset();
                    }}
                    className="form__edit__button edit"
                  >
                    Save changes to description
                  </button>

                </div>
                )}
              </fieldset>
            </FormElement>
          )}
        />
      </div>
    </div>
  );
};

export default EditInvoiceDescriptionsForm;
